export const WIDGET_NAME_ACCOUNT_SUMMARY: string = 'account-summary';
export const WIDGET_NAME_DEAL_LOCATIONS: string = 'deal-locations';
export const WIDGET_NAME_DEAL_SOURCES_BY_BROKER: string = 'deal-sources-by-broker';
export const WIDGET_NAME_DEALS_IN_DUE_DILIGENCE: string = 'deals-in-due-diligence';
export const WIDGET_NAME_USER_DEAL_TASKS: string = 'user-deal-tasks';
export const WIDGET_NAME_USER_MENTIONS: string = 'user-mentions';
export const WIDGET_NAME_RECENT_DEAL_UPDATES: string = 'recent-deal-updates';
export const WIDGET_NAME_NEW_DEALS_BY_PERIOD: string = 'new-deals-by-period';
export const WIDGET_NAME_DEAD_DEAL_REASONS: string = 'dead-deal-reasons';
export const WIDGET_NAME_DEALS_BY_MSA: string = 'deals-by-msa';
export const WIDGET_NAME_DEALS_BY_TYPE: string = 'deals-by-type';
export const WIDGET_NAME_DEAL_PIPELINE_FUNNEL: string = 'deal-pipeline-funnel';
